import React, { FC, useEffect } from 'react';
import { useClaimAccountMutation } from '../../generated/types';
import { enqueueSnackbar } from 'notistack';
import { useHistory, useParams } from 'react-router-dom';
import i18next from 'i18next';
import { useQuery } from '../../common/hooks/use-query';
import BaseLayout from '../../components/layout/BaseLayout';
import ZenLoading from '../../components/loading/Loading';

const ClaimAccountPage: FC = () => {
    const { accountId } = useParams<{ accountId: string }>();
    const history = useHistory();
    const query = useQuery();
    const [claimAccount] = useClaimAccountMutation();

    useEffect(() => {
        claimAccount({
            variables: {
                accountId: parseInt(accountId),
                claimToken: query.get('token') as string,
            },
            update(_, { data }) {
                if (data) {
                    history.push(`/account/${accountId}/site-design`);
                }
            },
            onError: (e) => {
                console.log(e);
                enqueueSnackbar(i18next.t('onBoarding:message.claimAccount.failed'), { variant: 'error' });
            },
        });
    }, []);
    return (
        <>
            <BaseLayout showHeader={false} showFooter={false}>
                <div className="flex-auto flex-col p-32 flex items-center justify-center">
                    <ZenLoading />
                </div>
            </BaseLayout>
        </>
    );
};

export default ClaimAccountPage;
